import { type ComponentType, type Context, createContext } from 'react';

export type ModalComponentProps = {
	onClose: () => void;
	setShouldCloseOnEscapePress: (shouldCloseOnEscapePress: boolean) => void;
	setShouldCloseOnOverlayClick: (shouldCloseOnOverlayClick: boolean) => void;
	shouldCloseOnEscapePress?: boolean;
	shouldCloseOnOverlayClick?: boolean;
};

export type ModalComponent = ComponentType<ModalComponentProps>;

export const ModalContext: Context<{
	openModal: (component: ModalComponent) => void;
}> = createContext<{
	openModal: (component: ModalComponent) => void;
}>({
	openModal: () => {
		throw new Error(
			"To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-point-modal-context/ModalContextProvider';",
		);
	},
});
